export enum DeviceTableVariant {
    MERCHANT = "merchant",
    SUPPORT = "support",
    SUPPLIER = "supplier",
    SERVICE_CENTER = "service_center",
}

export enum DisplayTypes {
    ROOM_DISPLAY = "ROOM_DISPLAY",
    MEETING_DISPLAY = "MEETING_DISPLAY",
    GUEST_CHECK_IN = "GUEST_CHECK_IN",
}

export enum DeviceType {
    CLOUD_POS = "CLOUD_POS",
    SOFT_POS = "SOFT_POS",
    DISPLAY = "DISPLAY",
    CLOUD_CREDIT_CARD_READER = "CLOUD_CREDIT_CARD_READER",
    STAR_CLOUD_PRINTER = "STAR_CLOUD_PRINTER",
    RECEIPT_CONTROL = "RECEIPT_CONTROL",
}

export enum DeviceStatus {
    ONLINE = "ONLINE",
    OFFLINE = "OFFLINE",
    ACTIVE = "Active",
    INACTIVE = "Inactive",
}

export type StatusDetails = Readonly<{
    status: string
    message: string
}>

// Device Table Base
export interface DeviceBase {
    id: number
    name: string
    type: DeviceType | string
    statusDetails: StatusDetails
}

// Device Details
export type DeviceDetailsStatusDetails = Readonly<{
    status: string
    message: string
    hasDiagnostics?: boolean
}>

export type POSDetails = Readonly<{
    mode: string
}>

export type DeviceHistoryRecord = Readonly<{
    timestamp: string
    author: string
}>

export type DeviceHistory = Readonly<{
    created: DeviceHistoryRecord
    updated: DeviceHistoryRecord
}>

export type Shop = Readonly<{
    id: number
    name: string
}>

export type MerchantDetails = Readonly<{
    pinCode: string
}>
export type DeviceGroup = Readonly<{
    id: number
    name: string
}>
export type DeviceDetailsGroup = Readonly<{
    id: number
    name: string
    devices: Device[]
}>

export type DeviceDetails = Readonly<{
    id: number
    type: DeviceType | string
    name: string
    deviceGroup: DeviceDetailsGroup | null
    statusDetails: DeviceDetailsStatusDetails
    posDetails?: POSDetails
    serialNumber: string
    hardwareUid: string
    deviceNumber: string
    isActive?: boolean
    creditCardTerminalPOIID?: string
    defaultLanguage: string
    shop?: Shop
    history: DeviceHistory
    merchantDetails?: MerchantDetails
    mode?: string
    resource?: {
        id?: number
        name?: string
    }
    template?: {
        id?: number
        name?: string
    }
}>

export type Device = Readonly<{
    id: number
    type: DeviceType
    name: string
    statusDetails: StatusDetails
    deviceGroup?: DeviceGroup
}>

// DeviceDiagnostics
export type DeviceDiagnostics = Readonly<{
    subject: string
    message: string
}>

export type DeviceDetailsDiagnostics = Readonly<{
    device: {
        id: number
        type: DeviceType
    }
    diagnostics: DeviceDiagnostics[]
}>
